import React from 'react';
import { Modal } from 'react-bootstrap';

import useUser from 'hooks/useUser';

import { useAppDispatch } from 'store/hooks';
import { updateUser } from 'store/user/user.action';

import welcomeImg from 'assets/images/first_login/welcome.png';
import contactUsImg from 'assets/images/first_login/contactus.png';

import {
  ConclusionButton,
  ImageContainer,
  NextButton,
  OptionsContainer,
  PageContainer,
  SkipButton,
  TextContainer,
  VideoContainer,
} from './modal-welcome.styles';

enum Page {
  welcome,
  movie,
  conclusion,
}

export const ModalPresentation = () => {
  const dispatch = useAppDispatch();
  const { currentUser } = useUser();

  const [currentPage, setCurrentPage] = React.useState<number>(Page['welcome']);
  const [showModal, setShowModal] = React.useState<boolean>(
    currentUser?.isFirstLogin ?? false
  );

  const handleClose = () => {
    setShowModal(false);
    if (currentUser) {
      dispatch(
        updateUser({
          name: currentUser.name,
          companyName: currentUser.companyName || '',
          documentNumber: currentUser.documentNumber,
          email: currentUser.email,
          invoiceEmail: currentUser.invoiceEmail || '',
          isCompany: currentUser.isCompany,
          phone: currentUser.phone,
          whatsappNumber: currentUser.whatsappNumber,
          isWhatsappConfirmed: currentUser.isWhatsappConfirmed,
          isToVerifyWhatsapp: false,
          role: currentUser.role || '',
          isFirstLogin: false,
          changePassword: false,
          password: '',
          newPassword: '',
          isFinishUser: false,
        })
      );
    }
  };

  const nextPage = () => {
    setCurrentPage(
      currentPage < Page['conclusion'] ? currentPage + 1 : currentPage
    );
  };

  return (
    <Modal show={showModal} size="xl" onHide={handleClose}>
      <Modal.Body className="p-0">
        {currentPage === Page['welcome'] && <PageWelcome />}
        {currentPage === Page['movie'] && <PageVideo />}
        {currentPage === Page['conclusion'] && <PageContact />}
        <OptionsContainer>
          <SkipButton onClick={handleClose}>Pular</SkipButton>
          {currentPage !== Page['conclusion'] ? (
            <NextButton onClick={nextPage}>Próximo</NextButton>
          ) : (
            <ConclusionButton onClick={handleClose}>Fechar</ConclusionButton>
          )}
        </OptionsContainer>
      </Modal.Body>
    </Modal>
  );
};

const PageWelcome = () => (
  <PageContainer>
    <ImageContainer>
      <img src={welcomeImg} alt="Bem vindo" />
    </ImageContainer>
    <TextContainer>
      <h1>Bem vindo ao EnergyPass!</h1>
      <h4>
        Como é o seu primeiro acesso, preparamos um vídeo para auxiliar os seus
        primeiros passos.
      </h4>
    </TextContainer>
  </PageContainer>
);

const PageVideo = () => (
  <VideoContainer
    src="https://www.youtube.com/embed/dZ0mZEVbd-g"
    allow="accelerometer; gyroscope; picture-in-picture"
    allowFullScreen
    title="Bem vindo ao EnergyPass"
  />
);

const PageContact = () => (
  <PageContainer>
    <ImageContainer>
      <img src={contactUsImg} alt="Entre em contato" />
    </ImageContainer>
    <TextContainer>
      <h1>Ainda ficou com alguma dúvida?</h1>
      <h4>
        Fique tranquilo, você pode conversar com a equipe EnergyPass utilizando
        o nosso botão de Chat ou WhatsApp sempre que precisar! (Atendimento em
        horário comercial).
      </h4>
      <h4>Seja bem-vindo ao EnergyPass!</h4>
    </TextContainer>
  </PageContainer>
);
